module.exports = __webpack_public_path__ + "img/03.46185091.png";